import React from 'react';
import { Paper, Stack, Typography } from '@mui/material';
import { useTotalCountingUp } from './scoreCountUp';

function StudentScoreBar({ displayName, totalScore }) {
    const displayed = useTotalCountingUp(totalScore);

    return (
        <Paper
            variant="outlined"
            data-testid="student-score-bar"
            sx={{
                position: 'sticky',
                top: 0,
                zIndex: 1,
                mx: 'auto',
                mb: 3,
                maxWidth: 480,
                px: 2.5,
                py: 1.25,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
            }}
        >
            <Typography sx={{ fontWeight: 700 }} noWrap>
                {displayName}
            </Typography>
            <Stack direction="row" spacing={0.75} alignItems="baseline">
                <Typography data-testid="total-score" sx={{ fontWeight: 800, fontSize: '1.3rem', color: 'primary.main' }}>
                    {displayed}
                </Typography>
                <Typography variant="body2" color="text.secondary">pts</Typography>
            </Stack>
        </Paper>
    );
}

export default StudentScoreBar;
